import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import AppRoutes from './routes';
import { Routes, Route, useLocation, Link } from 'react-router-dom';
import CookieConsentBanner from './components/CookieConsent';

// Add this to make react-snap work with react-helmet-async
const helmetContext = {};

function App() {
  const location = useLocation();
  
  // Add hash fragment navigation handling
  useEffect(() => {
    // Handle hash fragment scrolling
    if (location.hash) {
      // Small delay to ensure the DOM is fully loaded
      setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else if (location.pathname !== window.location.pathname) {
      // Scroll to top when navigating to a new page without hash
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <HelmetProvider context={helmetContext}>
      <div className="min-h-screen">
        <Navbar />
        
        {/* Routes for all paths - now includes homepage */}
        <AppRoutes />
        
        {/* Footer always visible */}
        <footer className="bg-white border-t py-8 mt-8">
          <div className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row items-center justify-between">
              {/* Copyright */}
              <p className="text-gray-600 text-sm mb-4 md:mb-0">
                &copy; {new Date().getFullYear()} BetterByAI. All Rights Reserved.
              </p>
              
              {/* Policy Links */}
              <div className="flex items-center space-x-6">
                <Link 
                  to="/privacy" 
                  className="text-gray-600 text-sm hover:text-[#FF7066] transition-colors"
                >
                  Privacy Policy
                </Link>
                <Link 
                  to="/cookie-policy" 
                  className="text-gray-600 text-sm hover:text-[#FF7066] transition-colors"
                >
                  Cookie Policy
                </Link>
              </div>
            </div>
          </div>
        </footer>
        
        {/* Only show cookie consent banner in browser environment */}
        {typeof navigator !== 'undefined' && <CookieConsentBanner />}
      </div>
    </HelmetProvider>
  );
}

export default App;
